import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient'; // Correct path to supabaseClient in src
import { toast } from 'react-toastify';
import backgroundImage from '../background.webp'; // Correct path to background.webp in src
import cardbackground from '../cardbackground.webp'; // Correct path to cardbackground.webp in src
import animation6 from '../assets/animations/animation6.webp';
import animation7 from '../assets/animations/animation7.webp';
import animation8 from '../assets/animations/animation8.webp';
import animation9 from '../assets/animations/animation9.webp';
import animation10 from '../assets/animations/animation10.webp';
import buttonImage from '../buttonimage.webp';

const EndofSession = ({ navigateTo, goBack, goHome }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [tally, setTally] = useState({ session_count: 0, last_session_date: null, completion_method: null });
  const [currentAnimIndex, setCurrentAnimIndex] = useState(0);
  const [showFinalImage, setShowFinalImage] = useState(false);

  // Define animationSequence here so it's available in the component
  const animationSequence = [animation6, animation7, animation8, animation9, animation10];

  useEffect(() => {
    const fetchTally = async () => {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      if (userError || !user) {
        toast.error('User not logged in.');
        return;
      }

      const { data: profile, error: profileError } = await supabase
        .schema('api')
        .from('user_profiles')
        .select('session_count, last_session_date, completion_method')
        .eq('id', user.id)
        .single();

      if (profileError) {
        console.error('Error fetching profile:', profileError.message);
        toast.error('Failed to fetch session data.');
        return;
      }

      setTally({
        session_count: profile.session_count || 0,
        last_session_date: profile.last_session_date ? new Date(profile.last_session_date).toLocaleDateString() : 'None',
        completion_method: profile.completion_method || 'None',
      });
    };

    fetchTally();
  }, []);

  useEffect(() => {
    // Play animation sequence, then show animation11.webp
    if (currentAnimIndex < animationSequence.length) {
      const timer = setTimeout(() => {
        setCurrentAnimIndex((prev) => prev + 1);
      }, 900);
      return () => clearTimeout(timer);
    } else {
      setShowFinalImage(true);
    }
  }, [currentAnimIndex, animationSequence.length]);

  const handleSessionComplete = async () => {
    console.log('handleSessionComplete triggered');
    
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user) {
        console.error('User not logged in:', userError);
        toast.error('User not logged in.');
        return;
    }
    console.log('User fetched:', user);

    const { data: profile, error: profileError } = await supabase
        .schema('api')
        .from('user_profiles')
        .select('membership_type, session_count, session_complete')
        .eq('id', user.id)
        .single();

    if (profileError) {
        console.error('Error fetching profile:', profileError.message);
        toast.error('Failed to fetch user profile.');
        return;
    }
    console.log('Profile fetched:', profile);

    if (profile.membership_type === 'Free Subscription') {
        if (profile.session_complete) {
            console.log('Session already marked as complete for Free Subscription user. Showing popup only.');
            setShowPopup(true);
            return;
        }

        try {
            console.log('Updating user_profiles table for Free Subscription user...');
            const { error: updateError } = await supabase
                .schema('api')
                .from('user_profiles')
                .update({
                    last_session_date: new Date().toISOString(),
                    session_count: (profile.session_count || 0) + 1,
                    session_complete: true,
                    completion_method: 'clicked',
                })
                .eq('id', user.id);

            if (updateError) {
                console.error('Error updating profile:', updateError.message);
                toast.error('Failed to update session data: ' + updateError.message);
                return;
            }

            console.log('Profile updated successfully for Free Subscription user.');
            setTally((prevTally) => ({
                ...prevTally,
                session_count: (profile.session_count || 0) + 1,
                last_session_date: new Date().toLocaleDateString(),
                completion_method: 'clicked',
            })); // Update the UI immediately
            setShowPopup(true);
        } catch (err) {
            console.error('Unexpected error updating session data:', err);
            toast.error('An unexpected error occurred while completing the session.');
        }
        return;
    }

    // For other membership types
    try {
        console.log('Updating user_profiles table for non-Free Subscription user...');
        const { error: updateError } = await supabase
            .schema('api')
            .from('user_profiles')
            .update({
                last_session_date: new Date().toISOString(),
                session_count: (profile.session_count || 0) + 1,
                session_complete: true,
                completion_method: 'clicked',
            })
            .eq('id', user.id);

        if (updateError) {
            console.error('Error updating profile:', updateError.message);
            toast.error('Failed to update session data: ' + updateError.message);
            return;
        }

        console.log('Profile updated successfully for non-Free Subscription user.');
        setTally((prevTally) => ({
            ...prevTally,
            session_count: (profile.session_count || 0) + 1,
            last_session_date: new Date().toLocaleDateString(),
            completion_method: 'clicked',
        })); // Update the UI immediately
        toast.success('Well done! You have completed your session.');
    } catch (err) {
        console.error('Unexpected error updating session data:', err);
        toast.error('An unexpected error occurred while completing the session.');
    }
  };

  const cardStyle = {
    width: '90%',
    maxWidth: '400px',
    backgroundImage: `url(${cardbackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    marginBottom: '20px',
    padding: '20px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  };


  const textStyle = {
    fontFamily: 'Times New Roman, Times, serif',
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'center',
    lineHeight: '1.5',
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
        }}
      >
        <h2
          style={{
            fontFamily: 'Times New Roman, Times, serif',
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#4B5563',
            textAlign: 'center',
            marginTop: '16px',
          }}
        >
          Session Ended
        </h2>
        {/* Animation sequence card */}
        <div style={{
          width: '90%',
          maxWidth: '400px',
          backgroundImage: `url(${cardbackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          marginBottom: '20px',
          padding: '20px',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {!showFinalImage ? (
            <img
              src={animationSequence[Math.min(currentAnimIndex, animationSequence.length - 1)]}
              alt="Session Animation Sequence"
              style={{
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                marginBottom: '8px',
                width: '100%',
                maxWidth: '360px',
                background: '#000',
                outline: 'none',
                objectFit: 'contain'
              }}
            />
          ) : (
            <img
              src="/images/animation11.webp"
              alt="Session Animation"
              style={{
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                marginBottom: '8px',
                width: '100%',
                maxWidth: '360px',
                background: '#000',
                outline: 'none',
                objectFit: 'contain'
              }}
            />
          )}
        </div>
        <div style={{
          ...cardStyle,
          border: '2px solid black',
        }}>
          <p style={textStyle}>
            Thank you for completing your session. Click the Session Complete button below to keep count of your sessions and Celebrate how far you have come. Well done!<br /><br /><br />
          </p>
          <p style={textStyle}>
            Sessions Completed: {tally.session_count}<br />
            Last Session: {tally.last_session_date}<br />
            Completion Method: {tally.completion_method}
          </p>
        </div>
        <div style={cardStyle}>
          <button
            className="endofsession-btn"
            style={{
              backgroundImage: `url(${buttonImage})`,
              backgroundSize: 'cover',
              border: '2px solid black',
              borderRadius: '10px',
              padding: '10px 30px',
              width: 'auto',
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '18px',
              fontWeight: 'bold',
              boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
              color: 'white',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
            onClick={handleSessionComplete}
          >
            Session Complete
          </button>
          <button
            className="endofsession-btn"
            style={{
              backgroundImage: `url(${buttonImage})`,
              backgroundSize: 'cover',
              border: '2px solid black',
              borderRadius: '10px',
              padding: '10px 30px',
              width: 'auto',
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '18px',
              fontWeight: 'bold',
              boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
              color: 'white',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
            onClick={() => navigateTo('knowThyself')}
          >
            Know Thyself
          </button>
        </div>
        <div
          className="endofsession-btn-row"
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            marginTop: '16px',
            width: '100%',
            maxWidth: '400px',
          }}
        >
          <button
            className="endofsession-btn"
            style={{
              backgroundImage: `url(${buttonImage})`,
              backgroundSize: 'cover',
              border: '2px solid black',
              borderRadius: '10px',
              padding: '10px 30px',
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'white',
              boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
            onClick={goBack}
          >
            Back
          </button>
          <button
            className="endofsession-btn"
            style={{
              backgroundImage: `url(${buttonImage})`,
              backgroundSize: 'cover',
              border: '2px solid black',
              borderRadius: '10px',
              padding: '10px 30px',
              fontFamily: 'Times New Roman, Times, serif',
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'white',
              boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
            onClick={goHome}
          >
            Home
          </button>
        </div>
        {showPopup && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '10px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              maxWidth: '90%',
              width: '400px',
              textAlign: 'center',
              zIndex: 1000,
            }}
          >
            <p
              style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '16px',
                color: '#333',
                marginBottom: '20px',
              }}
            >
              Well Done! You have completed your free monthly session. Upgrade to a Monthly or Yearly Subscription for unlimited sessions. Your free session resets every 30 days.
            </p>
            <button
              style={{
                backgroundColor: '#4B5563',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '10px',
                marginRight: '10px',
                fontFamily: 'Times New Roman, Times, serif',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
              onClick={() => navigateTo('myAccount')}
            >
              Upgrade Now
            </button>
            <button
              style={{
                backgroundColor: '#4B5563',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '10px',
                fontFamily: 'Times New Roman, Times, serif',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
              onClick={() => setShowPopup(false)}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default EndofSession;